import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_TEL } from "@/lib/site";
import { useScrollTo } from "./SmoothScroll";

export const FinalCta = () => {
  const scrollTo = useScrollTo();
  return (
    <section data-testid="final-cta-section" className="px-3 py-10 sm:px-5">
      <div className="relative mx-auto max-w-[1400px] overflow-hidden rounded-[32px] bg-gradient-to-br from-[#1638c9] via-[#0d2275] to-[#060d2e] px-6 py-24 sm:px-12 sm:py-32">
        <div className="grid-lines pointer-events-none absolute inset-0 opacity-60" />
        <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-gold/30 blur-[120px]" />
        <div className="pointer-events-none absolute -bottom-32 -left-20 h-96 w-96 rounded-full bg-royal2/40 blur-[120px]" />
        <div className="relative mx-auto max-w-4xl text-center">
          <Reveal>
            <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-7xl">
              Your Dream Website Is Just <span className="text-gold-grad italic">One Click</span> Away!
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-blue-100 md:text-lg">
              Give your business the online presence it deserves. Get a beautiful, professional, and affordable website with Pratap Group.
            </p>
          </Reveal>
          <Reveal delay={0.2} className="mt-12 flex flex-col justify-center gap-4 sm:flex-row">
            <a href="/#contact" onClick={(e) => scrollTo("contact", e)} data-testid="final-cta-quote-button" className="btn-gold btn-shine group inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-semibold transition-transform duration-300 hover:-translate-y-0.5">
              Get Your Free Quote <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <a href={PHONE_TEL} data-testid="final-cta-call-button" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/5 px-8 py-4 text-sm font-semibold text-white backdrop-blur transition-colors duration-300 hover:bg-white hover:text-[#0d2275]">
              <Phone className="h-4 w-4" /> Call Now: 9999377037
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
